export const statusDescription = {
  "1": "Open",
  "2": "Closed"
}

export const ERROR_REPORT_STATUS_OPEN = 1;
export const ERROR_REPORT_STATUS_CLOSE = 2;